import React from "react";
import Page from "../component/Page/Page";
import GridEntityService from "./GridEntityService";
import ByondGrid2 from "./CustomGrid";
import CustomGridHeader from "./CustomGridHeader";
import GridEndpointService from "./GridEndpointService";
import LoadingV2 from "../component/Loading/LoadingV2";
import {ControlLabel, FormGroup} from "react-bootstrap";
import Switch from "react-switch";
import CustomCardGrid from "../component/Card/customCardGrid/CustomCardGrid";

class ListPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      customFilter: {},
      selectedItems: [],
      displayType: false
    };
    this.getGridMetadata = this.getGridMetadata.bind(this);
  }

  componentWillMount() {
    this.getGridMetadata(this.props);
  }

  onSelectItem = (itemSelected) => {
    const {selectedItems} = this.state;
    selectedItems.push(itemSelected);
    this.setState({selectedItems: selectedItems});
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.match.params !== this.props.match.params) {
      this.getGridMetadata(nextProps);
      this.setState({displayType: false})
    }
  }

  getGridMetadata(props) {
    const {match} = props;
    const metadata = GridEntityService.getEntity(match.params.entity);
    this.setState({metadata: metadata, customFilter: metadata.customFilters});
  }

  onChange(newCustomFilter) {
    const clonedObject = JSON.parse(JSON.stringify(newCustomFilter));
    this.setState({customFilter: clonedObject});
  }

  refreshState = () => {
    this.setState({});
  };

  toggleChecked() {
    this.setState({
      displayType: !this.state.displayType
    });
  }

  render() {
    const {match, history} = this.props;
    const {metadata, customFilter} = this.state;
    const endpoint = GridEndpointService.getUrl(metadata.endpoint, this.props, this.state);

    const customHeader = metadata.customHeader ? metadata.customHeader(
      this.props,
      this.state,
      (value) => this.onChange(value),
      this.refreshState) : '';

    const customFilterComponent = metadata.customFilterComponent ? metadata.customFilterComponent(
      this.props,
      this.state,
      (value) => this.onChange(value),
      this.refreshState) : '';

    const customBreadcrumbs = metadata.customBreadcrumbs || null

    const headerCustom = <CustomGridHeader endpoint={endpoint}
                                           match={match}
                                           history={history}
                                           metadata={metadata}
                                           customHeader={customHeader}
                                           customFilterComponent={customFilterComponent}
    />;
    return (
      <Page headerCustom={headerCustom} breadcrumbs={customBreadcrumbs}>
        <LoadingV2 isLoading={endpoint === false}>
          <FormGroup>
            <ControlLabel>Tabela / Card</ControlLabel>
            <br/>
            <Switch
              width={50}
              onColor={'#00cfc3'}
              offColor={"#00cfc3"}
              uncheckedIcon={false}
              checkedIcon={false}
              checked={this.state.displayType}
              onChange={() => this.toggleChecked()}/>
          </FormGroup>
          {this.state.displayType === false ?
            <ByondGrid2 endpoint={endpoint} match={match} {...this.props}
                        defaultSort={metadata.defaultSort}
                        onItemSelected={this.onSelectItem}
                        customFilter={customFilter}
                        metadata={this.state.metadata}/> :
            <CustomCardGrid endpoint={endpoint} match={match} {...this.props}
                            onItemSelected={this.onSelectItem}
                            customFilter={customFilter}
                            metadata={this.state.metadata}/>
          }
        </LoadingV2>
      </Page>
    );

  }
}

export default ListPage;



// WEBPACK FOOTER //
// ./src/customGrid/ListPage.js